
import { Dialog } from 'element-ui';
export default {
  components: {
    ElDialog: Dialog,
  },
  props: {
    // 是否显示当前组件
    show: {
      type: Boolean,
      default: false,
    },
    // 是否居中显示
    center: {
      type: Boolean,
      default: true,
    },
    // 是否显示右上角关闭按钮
    showClose: {
      type: Boolean,
      default: false,
    },
    // 是否可以通过点击 modal 关闭 Dialog
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    // 是否可以通过按下 ESC 关闭 Dialog
    closeOnPressEscape: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      link: {
        url: '',
        text: '',
      },
      errorTip: '', // 错误提示
    };
  },
  methods: {
    cancel() {
      this.link.url = '';
      this.link.text = '';
      this.errorTip = '';
      this.$emit('cancel');
    },
    confirm() {
      const { url, text } = this.link;
      let errorText = '';
      const reg =
        '^((https?):\\/\\/)?([a-z]([a-z0-9\\-]*[\\.。])+([a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel)|(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))(\\/[a-zA-Z0-9_\\-\\.~]+)*(\\/([a-zA-Z0-9_\\-\\.]*)(\\?[a-zA-Z0-9+_\\-\\.%=&]*)?)?(#[a-z][a-zA-Z0-9_]*)?$';
      if (url === '' && text === '') {
        errorText = '请填写超链接地址';
      } else if (url === '') {
        errorText = '请填写超链接地址';
      } else if (!url.match(reg)) {
        errorText = '所填写超链接不合规';
      }
      if (errorText) return (this.errorTip = errorText);
      this.$emit('confirm', {
        url,
        text: text ? text : url,
      });
      this.link.url = '';
      this.link.text = '';
      this.errorTip = '';
    },
  },
};
